import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule, IMAGE_LOADER, ImageLoaderConfig, NgOptimizedImage } from '@angular/common';
import { ObjectFitOptions } from './shared-ui-cdn-image.config';

@Component({
  selector: 'lib-shared-ui-cdn-image',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage],
  templateUrl: './shared-ui-cdn-image.component.html',
  styleUrl: './shared-ui-cdn-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: IMAGE_LOADER,
      useValue: SharedUiCdnImageComponent.agilityCdnImageLoader,
    },
  ],
})
export class SharedUiCdnImageComponent {
  @Input({ required: true }) src!: string;
  @Input() width = 0;
  @Input() height = 0;
  @Input() sizes = '';
  @Input() isPriority = false;
  @Input() showPlaceholder = false;
  @Input() hasRoundedCorners = false;
  @Input() alt?: string;
  @Input() objectFit?: ObjectFitOptions;

  static agilityCdnImageLoader = (config: ImageLoaderConfig): string => {
    const encodedSrc = encodeURI(config.src);
    if (!config.width) {
      return encodedSrc;
    }

    return encodedSrc.includes('?')
      ? `${encodedSrc}&w=${config.width}`
      : `${encodedSrc}?q=90&format=auto&w=${config.width}`;
  };
}
